import React from "react";
import { FaArrowRight } from "react-icons/fa";
import "./EmailSubscription.css";

const EmailSubscription = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    const email = "info@web5solution.com";
    subscribeEmail(email);
  };

  const subscribeEmail = (email) => {
    console.log(`Subscribed web5 Solution`);
    alert(`Subscribed web5 Solution`);
  };

  return (
    <div className="">
      <form onSubmit={handleSubmit} className="subscription-form">
        <input
          type="email"
          name="email"
          placeholder="Enter your email"
          required
        />
        <button type="submit">
          <FaArrowRight />
        </button>
      </form>
    </div>
  );
};

export default EmailSubscription;
